/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Collapse } from 'react-collapse'

import { collapsibleClick } from '@cred/react-analytics/events'
import { withSnowplowContexts } from '@cred/react-analytics/SnowplowContextManager'

import { defaultProducts } from '../../common/constants'
import MortgageCombinedTile from '../mortgage-combined-tile/MortgageCombinedTile'
import styles from './styles.module.scss'

const ShortDashboard = ({ products, trackSnowplowEvent, ...props }) => {
  const [isOpen, setIsOpen] = useState(false)
  let bestProducts
  switch (products.length) {
    case 0:
      bestProducts = defaultProducts
      break
    case 1:
    case 2:
    case 3:
      bestProducts = products
      break
    default:
      bestProducts = products.slice(0, 3)
  }
  const hiddenProducts = products.length > 3 ? products.slice(3, products.length) : []
  const collapseToggle = () => {
    setIsOpen(!isOpen)
    trackSnowplowEvent(collapsibleClick, {
      text: `View ${hiddenProducts.length} more lender${hiddenProducts.length > 1 ? 's' : ''}`,
      action: isOpen ? 'collapse' : 'expand',
    })
  }
  return (
    <>
      {bestProducts.map((product, index) => (
        <MortgageCombinedTile index={index} product={product} key={product.uuid} {...props} />
      ))}
      {products.length > 3 && (
        <>
          {!isOpen && (
            <div onClick={collapseToggle} className={styles.collapseHeader}>
              <p className="bodySmall secondary500 semiBold">
                View {hiddenProducts.length} more lender{hiddenProducts.length > 1 ? 's' : ''}{' '}
                <i className="cred-icon icon-chevron-down" />
              </p>
            </div>
          )}
          <Collapse isOpened={isOpen}>
            {hiddenProducts.map((product, index) => (
              <MortgageCombinedTile index={index} product={product} key={product.uuid} {...props} />
            ))}
          </Collapse>
          {isOpen && (
            <div onClick={collapseToggle} className={styles.collapseHeader}>
              <p className="bodySmall secondary500 semiBold">
                Hide additional lender{hiddenProducts.length > 1 ? 's' : ''}{' '}
                <i className="cred-icon icon-chevron-up" />
              </p>
            </div>
          )}
        </>
      )}
    </>
  )
}

ShortDashboard.propTypes = {
  products: PropTypes.array.isRequired,
  trackSnowplowEvent: PropTypes.func.isRequired,
}

export default withSnowplowContexts(ShortDashboard)
